import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AgencyInformationApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class AgencyInformationService {
  private apiUrl = 'agency-information';

  constructor(private readonly http: HttpClientService) {}

  public get(): Observable<AgencyInformationApiModel> {
    return this.http.get<AgencyInformationApiModel>(`${this.apiUrl}/get`);
  }

  public update(item: AgencyInformationApiModel): Observable<AgencyInformationApiModel> {
    return this.http.put<AgencyInformationApiModel>(`${this.apiUrl}/update`, item);
  }
}
